import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const goBack = () => {
    const index = window.history.state?.idx;
    if (typeof index === "number" && index > 0) {
      navigate(-1);
      return;
    }
    const token = localStorage.getItem("token");
    navigate(token ? "/dashboard" : "/", { replace: true });
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 80,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: "#0c0c0c",
        color: "#ffffff",
        padding: "24px",
      }}
    >
      <div className="nf-orb nf-orb-a" />
      <div className="nf-orb nf-orb-b" />

      <div className="relative z-10 w-full max-w-xl text-center">
        <p className="nf-kicker" style={{ color: "#FFCB05", fontSize: "12px", fontWeight: 700, letterSpacing: "0.35em", textTransform: "uppercase" }}>
          MTN Recruitment
        </p>

        <div className="mt-6 flex items-center justify-center gap-1 sm:gap-3" aria-hidden="true">
          <span className="nf-digit nf-d1" style={{ color: "#ffffff", fontSize: "8rem", fontWeight: 800, lineHeight: 1 }}>4</span>
          <span className="nf-zero relative mx-1 inline-flex h-24 w-24 items-center justify-center sm:h-32 sm:w-32">
            <span className="nf-ring" />
            <span style={{ color: "#FFCB05", fontSize: "8rem", fontWeight: 800, lineHeight: 1 }}>0</span>
          </span>
          <span className="nf-digit nf-d3" style={{ color: "#ffffff", fontSize: "8rem", fontWeight: 800, lineHeight: 1 }}>4</span>
        </div>

        <h1 className="nf-copy" style={{ marginTop: "16px", fontSize: "32px", fontWeight: 700, color: "#ffffff" }}>Page not found</h1>
        <p className="nf-copy nf-copy-late" style={{ margin: "12px auto 0", maxWidth: "28rem", color: "rgba(255,255,255,0.75)", lineHeight: 1.6 }}>
          This page is not part of the recruitment system. Go back to where you were.
        </p>

        <button
          type="button"
          onClick={goBack}
          className="nf-copy nf-copy-late"
          style={{
            marginTop: "32px",
            border: 0,
            borderRadius: "999px",
            background: "#FFCB05",
            color: "#000000",
            fontWeight: 700,
            fontSize: "16px",
            padding: "12px 32px",
            cursor: "pointer",
          }}
        >
          Go back
        </button>
      </div>

      <style>{`
        .nf-orb {
          position: absolute;
          border-radius: 9999px;
          filter: blur(40px);
          opacity: 0.55;
          pointer-events: none;
        }
        .nf-orb-a {
          width: 280px;
          height: 280px;
          background: #FFCB05;
          top: -80px;
          left: -60px;
          animation: nf-float 7s ease-in-out infinite;
        }
        .nf-orb-b {
          width: 340px;
          height: 340px;
          background: #FFCB05;
          right: -120px;
          bottom: -140px;
          opacity: 0.28;
          animation: nf-float 9s ease-in-out infinite reverse;
        }
        .nf-digit, .nf-kicker, .nf-copy {
          animation: nf-rise 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) both;
        }
        .nf-d1 { animation-delay: 0.05s; }
        .nf-d3 { animation-delay: 0.28s; }
        .nf-copy { animation-delay: 0.4s; }
        .nf-copy-late { animation-delay: 0.52s; }
        .nf-zero {
          animation: nf-pop 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) 0.12s both;
        }
        .nf-ring {
          position: absolute;
          inset: 6px;
          border-radius: 9999px;
          border: 3px solid rgba(255, 203, 5, 0.35);
          border-top-color: #FFCB05;
          animation: nf-spin 2.8s linear infinite;
        }
        @keyframes nf-rise {
          from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes nf-pop {
          0% { opacity: 0; transform: scale(0.6); }
          70% { opacity: 1; transform: scale(1.08); }
          100% { opacity: 1; transform: scale(1); }
        }
        @keyframes nf-spin {
          to { transform: rotate(360deg); }
        }
        @keyframes nf-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(24px); }
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;
